import { Container, Row, Col, Button } from "react-bootstrap";

import VehicleFilters from "../../components/manageVehicle/VehicleFilters";
import StatsCard from "../../components/dashboard/StatsCard";
import { FaKey } from "react-icons/fa";
import { IoTimer } from "react-icons/io5";
import { BsFillCalendar2DateFill, } from "react-icons/bs";
import { RiSendPlaneFill, } from "react-icons/ri";
import GateCodesTable from "./GateCodesTable";
import { useEffect, useState } from "react";
import { getBookingAnalyticsAPI, getBookingHistoryAPI, getMultipleBookingHistoryAPI } from "../../services/Networkcall";
import { errorAlert } from "../../components/common/Alert";
import { Loader } from "../../components/common/Loader";
import GateCodeFilters from "./GateCodeFilters";
import moment from "moment";
import BookingTable from "../../components/dashboard/BookingTable";
import GateCodesTableMultiple from "./GateCodeStableMultiple";

export default function GateCode() {

  const [singleBookings, setSingleBookings] = useState(null);
  const [multipleBookings, setMultipleBookings] = useState(null);
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [singleBookingPagination, setSingleBookingPagination] = useState({ page: 1, totalPages: 1, limit: 10, totalRecords: 1 })
  const [multipleBookingPagination, setMultipleBookingPagination] = useState({ page: 1, totalPages: 1, limit: 10, totalRecords: 1 })
  const [filters, setFilters] = useState({ search: '', startDate: '', endDate: '', status: 'All', locationId: '' })
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [bookingMode, setBookingMode] = useState("multiple");
  const [refetch, setRefetch] = useState(false);

 
  // ==================FETCH ALL BOOKINGS=================
  const fetchBookingHistory = async () => {
    setLoading(true);
    const payload = {
      page: singleBookingPagination?.page,
      limit: singleBookingPagination?.limit,
      status: filters.status || 'All',
      search: debouncedSearch,
      locationId: filters?.locationId || '',
      startDate: filters?.startDate ? moment(filters.startDate).startOf('day').utc().format() : '',
      endDate: filters?.endDate ? moment(filters.endDate).endOf('day').utc().format() : '',
    }
    try {
      const res = await getBookingHistoryAPI(payload);
      if (res?.success) {
        setSingleBookings(res?.data || [])
        setSingleBookingPagination((pre) => ({ ...pre, totalPages: res?.totalNumberOfPages, totalRecords: res?.totalRecords }))
      } else {
        errorAlert({ message: res?.message });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "something went wrong" })
    } finally {
      setLoading(false);
    }
  }

  const fetchMultipleBookingHistory = async () => {
    setLoading(true);
    const payload = {
      page: multipleBookingPagination?.page,
      limit: multipleBookingPagination?.limit,
      status: filters.status || 'All',
      search: debouncedSearch,
      locationId: filters?.locationId || '',
      startDate: filters?.startDate ? moment(filters.startDate).startOf('day').utc().format() : '',
      endDate: filters?.endDate ? moment(filters.endDate).endOf('day').utc().format() : '',
    }
    try {
      const res = await getMultipleBookingHistoryAPI(payload);
      if (res?.success) {
        setMultipleBookings(res?.data || [])
        setMultipleBookingPagination((pre) => ({ ...pre, totalPages: res?.totalNumberOfPages, totalRecords: res?.totalRecords }))
      } else {
        errorAlert({ message: res?.message });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "something went wrong" })
    } finally {
      setLoading(false);
    }
  }

  const fetchAnalyticsData = async () => {
    setLoading(true);
    try {
      const res = await getBookingAnalyticsAPI();
      if (res?.success) {
        setAnalytics(res?.data || [])
      } else {
        errorAlert({ message: res?.message });
      }
    } catch (err) {
      errorAlert({ message: err?.response?.data?.message || err?.message || "something went wrong" })
    } finally {
      setLoading(false);
    }
  }

  // ==================HANDLLE PAGINATION=================
  const singleBookingPageHandler = (page) => {
    setSingleBookingPagination((pre) => ({ ...pre, page: page }));
  }

  const multipleBookingPageHandler = (page) => {
    setMultipleBookingPagination((pre) => ({ ...pre, page: page }));
  }

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setDebouncedSearch(filters.search);
      setLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [filters.search]);

  // ==================Effect=================
  useEffect(() => {
    if (bookingMode === "single") {
      fetchBookingHistory();
    } else {
      fetchMultipleBookingHistory();
    }
  }, [bookingMode, singleBookingPagination.page, multipleBookingPagination.page, debouncedSearch, filters.status, filters.startDate, filters.endDate, filters.locationId])

  useEffect(() => { fetchAnalyticsData(); }, [])
  
  useEffect(() => {
    if (refetch) {
        fetchMultipleBookingHistory();
        setRefetch(false);  
    }
}, [refetch]);

  const clearFilter = () => {
    setFilters({ search: '', startDate: '', endDate: '', status: 'All', locationId: '' })
  }

  return (
    <Container fluid className="mv-page">
      <Loader show={loading} />

      {/* HEADER */}
      <div className="mv-header">
        <div>
          <h3>Gate Code</h3>
          <p>View, manage send gate code to driver.</p>
        </div>

        {/* <Button className="mv-add-btn">+ Generate Gate Code</Button> */}
      </div>

      <Row className="g-2">
        <Col md={4}>
          <StatsCard
            title="Active Codes"
            value={analytics?.totalActive || 0}
            color="#0bb41c"
            bgColor="#eeffec"
            icon={FaKey}
            className="mt-0"
          />
        </Col>
        <Col md={4}>
          <StatsCard
            title="Expiring Soon (in 3 days)"
            value={analytics?.totalExpiringSoon || 0}
            color="#ff8c00"
            bgColor="#fff0de"
            icon={IoTimer}
            className="mt-0"
          />
        </Col>
        <Col md={4}>
          <StatsCard
            title="Expired (Last 30 days)"
            value={analytics?.totalExpired || 0}
            color="#d21919"
            bgColor="#ffe9e9"
            icon={BsFillCalendar2DateFill}
            className="mt-0"
          />
        </Col>
        {/* <Col md={3}>
                    <StatsCard
                        title="Send (Last 30 days)"
                        value="37"
                        color="#0066ff"
                        bgColor="#d1e3ff"
                        icon={RiSendPlaneFill}
                        className="mt-0"
                    />
                </Col> */}
      </Row>
      {/* FILTERS */}
      <GateCodeFilters filters={filters} setFilters={setFilters} />

      {/* TABLE */}
      {/* <div className="px-3 pt-2">
        <div className="booking-tabs">
          <div
            className={`tab ${bookingMode === "single" ? "active" : ""}`}
            onClick={() => { setBookingMode("single"); clearFilter(); }}
          >
            Single Booking
          </div>

          <div
            className={`tab ${bookingMode === "multiple" ? "active" : ""}`}
            onClick={() => { setBookingMode("multiple"); clearFilter(); }}
          >
            Multiple Booking
          </div>
        </div>
      </div> */}

      {bookingMode === "single" ? (
        <GateCodesTable
          border={true}
          bookings={singleBookings}
          pagination={singleBookingPagination}
          pageHandler={singleBookingPageHandler}
        />
      ) : (
        <GateCodesTableMultiple
          border={true}
         setRefetch={setRefetch} 
          bookings={multipleBookings}
          pagination={multipleBookingPagination}
          pageHandler={multipleBookingPageHandler}
        />
      )}
    </Container>
  );
}